import { render, staticRenderFns } from "./WfDevComplaintList.vue?vue&type=template&id=60426190&scoped=true&"
import script from "./WfDevComplaintList.vue?vue&type=script&lang=js&"
export * from "./WfDevComplaintList.vue?vue&type=script&lang=js&"
import style0 from "./WfDevComplaintList.vue?vue&type=style&index=0&id=60426190&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60426190",
  null
  
)

export default component.exports